import React from 'react';
import * as Yup from 'yup';
import { Formik } from "formik";

const validationSchema = Yup.object({
    nombre: Yup.string(),
    tipo:Yup.string()
});


export default function FiltroRegistros(props) {
    const { Filter,children } = props;
    return (
        <Formik
            initialValues={{
                nombre: '',
                tipo: '',
            }}
            validationSchema={validationSchema}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                Filter(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <form onSubmit={handleSubmit} autoComplete="off" >
                    <div className='row'>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Nombre:</label>
                                <input type="text" name='nombre' className='form-control form-control-sm' value={values.nombre || ''} onChange={handleChange} />
                                <span className="help-block">{errors.nombre}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Tipo sorteo:</label>
                                <select name="tipo" id="tipo" className='form-select form-select-sm' value={values.tipo || ''} onChange={handleChange}>
                                    <option value="">Todos</option>
                                    <option value="1">Primer lugar</option>
                                    <option value="2">Segundo lugar</option>
                                </select>
                                <span className="help-block">{errors.tipo}</span>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group" style={{ paddingTop: '30px' }}>
                                <button type='submit' className='btn btn-primary btn-sm mt-30'>Buscar</button>
                                {children}
                            </div>
                        </div>
                    </div>
                </form>
            }
        </Formik>
    )
}
